"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var style_1 = require("@lyearn/style");
function SvgDownload(_props, svgRef) {
    var props = (0, style_1.useSvg)(_props);
    return (React.createElement("svg", tslib_1.__assign({ width: 24, height: 24, viewBox: "0 0 24 24", ref: svgRef }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.003 12.076A1.06 1.06 0 0111 12V4a1 1 0 112 0v8l2.4-1.8a1 1 0 111.2 1.6l-4 3a1 1 0 01-1.175.018l-4-2.814a1 1 0 111.15-1.636l2.428 1.708zM6 17v1h12v-1c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1H5c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1s1 .45 1 1z" })));
}
exports["default"] = React.forwardRef(SvgDownload);
//# sourceMappingURL=Download.js.map